import React from 'react';
import './portfolio.css';
import { Link } from 'react-router-dom';

const Portfolio = () => {
    return (
        <div className="portfolio-section products_container " style={{ marginTop: '6%' }}>

            <div className="portfolio-header mb-5 ">
                <div className=' subheading'>Explore Our Portfolios</div>
                <div className='services_heading highlight'>Experience the Difference</div>
                <div className='porfolio-subtext services_subheading'>
                    The success of any project hinges on multiple factors, but aligning with our clients' goals is our top priority.
                    When we collaborate closely, success naturally follows! Discover how we turn visions into reality.
                </div>
            </div>



            <div className="row g-5 mb-5  align-items-center">
                <div className="col-lg-5 fadeInUp portfolio-contant-box mobile-portfolio-item" data-wow-delay="0.2s">
                    <div className="portfolio-logo-section">
                        <img src="img/lm.png" alt="TRISPIRE Logo" className="portfolio-logo" style={{ border: "2px solid black" }} />
                        <div className='portfolio-logo-text'>
                            <div className="portfolio-title">Linkomatic</div>
                            <div className="services_subheading">
                                <span className='highlight'>TECHNOLOGY:</span> PYTHON | NODE JS | REACT JS
                            </div>
                        </div>
                    </div>
                    <div className="subheading mb-4">Linkomatic</div>
                    <div className="services_subheading mb-4">LinkoMatic is a specialized tool designed to simplify and automate LinkedIn-based outreach and lead generation using AI. It's targeted at users wanting to generate premium high-ticket leads, with minimal manual work and no ad spend. Keep in mind limitations due to platform policies and evolving feature sets. Always review current pricing and terms before committing.

                        If you'd like help comparing this to alternatives, reviewing user feedback or compliance with LinkedIn's ever‑changing API rules, feel free to ask!</div>
                    <div className="image-section2 d-lg-none">
                        <img className="portfolio-image2" src="img/linkomatic (2).png" alt="Linkomatic" />
                    </div>
                    <div className="portfolio-button-container">
                        <Link to="https://linkomatic.ai/" target="_blank">
                            <button className="portfolio-button">Read Details</button>
                        </Link>
                    </div>
                </div>

                <div className="col-lg-7 wow zoomIn d-none d-lg-block" data-wow-delay="0.5s">
                    <div className="image-section2">
                        <img className="portfolio-image2" src="img/linkomatic (2).png" alt="Linkomatic" />
                    </div>
                </div>
            </div>

            <div className="row g-5 mb-5  align-items-center">
                <div className="col-lg-7 wow zoomIn d-none d-lg-block" data-wow-delay="0.5s">
                    <div className="image-section2">
                        <img className="portfolio-image2" src="img/sooper_ai.png" alt="Sooper AI" />
                    </div>
                </div>

                <div className="col-lg-5 fadeInUp portfolio-contant-box mobile-portfolio-item" data-wow-delay="0.2s">
                    <div className="portfolio-logo-section">
                        <img src="img/sooper.png" alt="sooper" className="portfolio-logo" style={{ border: '2px solid black' }} />
                        <div className='portfolio-logo-text'>
                            <div className="portfolio-title">Sooper ai</div>
                            <div className="services_subheading">
                                <span className='highlight'>TECHNOLOGY:</span> NodeJS | NEXT JS | REACT JS | AI | PYTHON
                            </div>
                        </div>
                    </div>
                    <div className="subheading mb-4">Sooper Ai website </div>
                    <div className="services_subheading mb-4">Sooper's AI algo deeply analyzes an investor's equity holdings across apps and customizes the entire portfolio for optimal return versus return.

                        The algo called "StockVector" uses LLM text embeddings to represent stocks as multidimensional vectors.

                        This enables it to uncover deep levels of hidden risks in equity portfolios which was not previously possible.It continuously learns from news, earnings reports, and market signals to adapt to evolving risks.
                        StockVector enables smart rebalancing by identifying overexposure, hidden correlations, and missed opportunities.
                        By combining advanced vector modeling with real-time data, Sooper helps investors make faster, safer, and smarter decisions.</div>
                    <div className="image-section2 d-lg-none">
                        <img className="portfolio-image2" src="img/sooper_ai.png" alt="Sooper AI" />
                    </div>
                    <div className="portfolio-button-container">
                        <Link to="https://sooper.ai/" target="_blank">
                            <button className="portfolio-button">Read Details</button>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="row g-5 mb-5  align-items-center">
                <div className="col-lg-5 fadeInUp portfolio-contant-box mobile-portfolio-item" data-wow-delay="0.2s">
                    <div className="portfolio-logo-section">
                        <img src="img/lm.png" alt="TRISPIRE Logo" className="portfolio-logo" style={{ border: '2px solid grey' }} />
                        <div className='portfolio-logo-text'>
                            <div className="portfolio-title">SEO management tool </div>
                            <div className="services_subheading">
                                <span className='highlight'>TECHNOLOGY:</span> PYTHON | REACT JS | AI
                            </div>
                        </div>
                    </div>
                    <div className="subheading mb-4">Smart Internal Link Automation  </div>
                    <div className="services_subheading mb-4">Linkomatic.ai is an AI-driven SEO management tool designed to automate internal linking across your website's content. By intelligently analyzing your blog posts, pages, and keywords, Linkomatic suggests and inserts relevant internal links—saving hours of manual effort and boosting your site's SEO performance.It's a must-have tool for content marketers, bloggers, SEO professionals, and agencies looking to scale content optimization with AI precision and speed.</div>
                    <div className="image-section1 d-lg-none">
                        <img className="portfolio-image1" src="img/internal_linkomatic.png" alt="Internal Linkomatic" />
                    </div>
                    <div className="portfolio-button-container">
                        <Link to="https://internal.linkomatic.ai/" target="_blank">
                            <button className="portfolio-button">Read Details</button>
                        </Link>
                    </div>
                </div>

                <div className="col-lg-7 wow zoomIn d-none d-lg-block" data-wow-delay="0.5s">
                    <div className="image-section1">
                        <img className="portfolio-image1" src="img/internal_linkomatic.png" alt="Internal Linkomatic" />
                    </div>
                </div>
            </div>

            <div className="row g-5 mb-5  align-items-center">
                <div className="col-lg-7 wow zoomIn d-none d-lg-block" data-wow-delay="0.5s">
                    <div className="image-section1">
                        <img className="portfolio-image1" src="img/apty.png" alt="Apty" />
                    </div>
                </div>
                <div className="col-lg-5 fadeInUp portfolio-contant-box mobile-portfolio-item" data-wow-delay="0.2s">
                    <div className="portfolio-logo-section">
                        <img src="img/apty_logo.png" alt="TRISPIRE Logo" className="portfolio-logo" style={{ border: '2px solid #ff0000' }} />
                        <div className='portfolio-logo-text'>
                            <div className="portfolio-title">Apty speak</div>
                            <div className="services_subheading">
                                <span className='highlight'>TECHNOLOGY:</span> PYTHON | NODE JS | AI | REACT NATIVE
                            </div>
                        </div>
                    </div>
                    <div className="subheading mb-4">Apty Speak App</div>
                    <div className="services_subheading mb-4">Apty Speak is a smart learning app built with React Native.
                        It offers a wide variety of professional and skill-based courses.
                        Users can easily browse and buy courses within the app.
                        The learning experience is guided by an AI-powered teacher.
                        AI provides instant feedback, explanations, and personal guidance.
                        Lessons are interactive with video, audio, and quizzes.
                        The app supports learning at your own pace, anytime, anywhere.
                        Progress tracking helps users stay motivated and focused.
                        Perfect for students, professionals, and lifelong learners.
                        Apty Speak makes learning simple, engaging, and intelligent.</div>
                    <div className="image-section1 d-lg-none">
                        <img className="portfolio-image1" src="img/apty.png" alt="Apty" />
                    </div>
                    <div className="portfolio-button-container">
                        <Link to="#">
                            <button className="portfolio-button">Read Details</button>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="row g-5 mb-5  align-items-center">
                <div className="col-lg-5 fadeInUp portfolio-contant-box mobile-portfolio-item" data-wow-delay="0.2s">
                    <div className="portfolio-logo-section">
                        <img src="img/sooper_money (2).png" alt="sooper" className="portfolio-logo" style={{ border: '2px solid black' }} />
                        <div className='portfolio-logo-text'>
                            <div className="portfolio-title">Sooper Money</div>
                            <div className="services_subheading">
                                <span className='highlight'>TECHNOLOGY:</span> NodeJS | NEXT JS | REACT JS | AI | PYTHON
                            </div>
                        </div>
                    </div>
                    <div className="subheading mb-4">Sooper Money website </div>
                    <div className="services_subheading mb-4">Discover and invest in thematic portfolios created by top influencers, powered by cutting-edge AI technology.
                        Track trending stocks driven by market sentiment, news, and social buzz in real-time.
                        Get exclusive access to influencer-backed strategies tailored to current market conditions.
                        Analyze portfolio performance with intuitive, data-rich visualizations.
                        Leverage AI to uncover hidden opportunities and manage risk smarter.
                        Follow expert-curated themes like green energy, AI innovation, and emerging tech.
                        Stay ahead with daily insights, alerts, and personalized investment recommendations.</div>
                    <div className="image-section2 d-lg-none">
                        <img className="portfolio-image2" src="img/sooper_money.png" alt="Sooper Money" />
                    </div>
                    <div className="portfolio-button-container">
                        <Link to="https://sooper-money.ai/" target="_blank">
                            <button className="portfolio-button">Read Details</button>
                        </Link>
                    </div>
                </div>
                <div className="col-lg-7 wow zoomIn d-none d-lg-block" data-wow-delay="0.5s">
                    <div className="image-section2">
                        <img className="portfolio-image2" src="img/sooper_money.png" alt="Sooper Money" />
                    </div>
                </div>
            </div>

            <div className="row g-5 mb-5  align-items-center">
                <div className="col-lg-7 wow zoomIn d-none d-lg-block" data-wow-delay="0.5s">
                    <div className="image-section2">
                        <img className="portfolio-image2" src="img/abitm.png" alt="ABITM" />
                    </div>
                </div>
                <div className="col-lg-5 fadeInUp portfolio-contant-box mobile-portfolio-item" data-wow-delay="0.2s">
                    <div className="portfolio-logo-section">
                        <img src="img/logo.jpg" alt="TRISPIRE Logo" className="portfolio-logo" style={{ border: "2px solid black" }} />
                        <div className='portfolio-logo-text'>
                            <div className="portfolio-title">Abitm</div>
                            <div className="services_subheading">
                                <span className='highlight'>TECHNOLOGY:</span> REACT JS | NODE JS | PYTHON
                            </div>
                        </div>
                    </div>
                    <div className="subheading mb-4">institute website</div>
                    <div className="services_subheading mb-4">In essence, abitm.com is the online presence of ABITM Institute in Kolkata, offering professional training in digital marketing and software fields. It delivers modern, industry-relevant content, promotes strong placement support, and frequently features promotional offers to drive engagement and enrollment.

                        Let me know if you'd like deep dives into specific course offerings, fee structure, placement partnerships, or comparisons with other training institutes!</div>
                    <div className="image-section2 d-lg-none">
                        <img className="portfolio-image2" src="img/abitm.png" alt="ABITM" />
                    </div>
                    <div className="portfolio-button-container">
                        <Link to="https://abitm.com/" target="_blank">
                            <button className="portfolio-button">Read Details</button>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="row g-5 mb-5  align-items-center">
                <div className="col-lg-5 fadeInUp portfolio-contant-box mobile-portfolio-item" data-wow-delay="0.2s">
                    <div className="portfolio-logo-section">
                        <img src="img/sooper.png" alt="TRISPIRE Logo" className="portfolio-logo" style={{ border: "2px solid black" }} />
                        <div className='portfolio-logo-text'>
                            <div className="portfolio-title">Chrome Extension</div>
                            <div className="services_subheading">
                                <span className='highlight'>TECHNOLOGY:</span> PYTHON | NODE JS | REACT JS
                            </div>
                        </div>
                    </div>
                    <div className="subheading mb-4">Browser Extension</div>
                    <div className="services_subheading mb-4">This Chrome Extension is a powerful AI-driven browser add-on developed using Python, Node.js, and React.js. It is designed to revolutionize the way users shop online by providing instant, contextual, and insightful product information right within their browser. By integrating seamlessly into e-commerce platforms like Amazon, this extension enriches the product browsing experience with intelligent summaries and data-driven recommendations.</div>
                    <div className="image-section2 d-lg-none">
                        <img className="portfolio-image2" src="img/extension.png" alt="Chrome Extension" />
                    </div>
                    <div className="portfolio-button-container">
                        <Link to="#">
                            <button className="portfolio-button">Read Details</button>
                        </Link>
                    </div>
                </div>
                <div className="col-lg-7 wow zoomIn d-none d-lg-block" data-wow-delay="0.5s">
                    <div className="image-section2">
                        <img className="portfolio-image2" src="img/extension.png" alt="Chrome Extension" />
                    </div>
                </div>
            </div>

       


        </div>
    );
};

export default Portfolio;
